<section #timeselected class="timeSelected">
  <div class="row w-100 align-items-center">
    <div class="d-flex">
      <div class="text col-6 d-flex align-items-end justify-content-end" (click)="this.pickerStage = 'hours'">
        <input
          type="number"
          class="inputTime"
          (beforeinput)="onBeforeInput($event)"
          [ngModel]="getFormattedNumber(selectedHour)"
          (ngModelChange)="selectedHour = $event; validateHour()"
          [ngStyle]="pickerStage === 'hours' ? { color: 'black', 'background-color': 'white' } : {}"
          min="-1"
          max="24"
          [readonly]="pickerStage !== 'hours'"
          (keydown)="preventArrowKeyChange($event)"
          [attr.aria-label]="'TIME_PICKER.HOURS' | translate"
        />
      </div>

      <div class="text text-center">
        <span>:</span>
      </div>

      <div class="text col-4 d-flex align-items-end justify-content-start" (click)="this.pickerStage = 'minutes'">
        <input
          type="number"
          class="inputTime"
          (beforeinput)="onBeforeInput($event)"
          [ngModel]="getFormattedNumber(selectedMinute)"
          (ngModelChange)="selectedMinute = $event; validateMinute()"
          [ngStyle]="pickerStage === 'minutes' ? { color: 'black', 'background-color': 'white', 'text-align': 'left' } : { 'text-align': 'left' }"
          min="-1"
          max="60"
          [readonly]="pickerStage !== 'minutes'"
          (keydown)="preventArrowKeyChange($event)"
          [attr.aria-label]="'TIME_PICKER.MINUTES' | translate"
        />
      </div>
    </div>
  </div>
</section>
<section
  #container
  class="clock"
  (pointerup)="calculateCursorAngle($event, false)"
  (pointermove)="calculateCursorAngle($event)"
  (pointerdown)="calculateCursorAngle($event, true)"
>
  @if (pickerStage === "hours") {
    <div>
      <div class="col-md" mat-dialog-content>
        <!-- <div #container mat-dialog-content> -->
        @for (hour of hours; track hour; let i = $index) {
          <div class="d-flex justify-content-center align-items-center">
            <div>
              @if (hourPositions[i]) {
                <div [ngStyle]="{ top: hourPositions[i].y + 'px', left: hourPositions[i].x + 'px' }" (dblclick)="selectHour(hour)" class="hour">
                  @if (hour === hours[selectedHour]) {
                    <button class="selectedButton" mat-flat-button>
                      {{ hour | number: "1.0-0" }}
                    </button>
                  }
                  @if (hour !== hours[selectedHour]) {
                    <button class="clockButton" mat-flat-button>
                      {{ hour | number: "1.0-0" }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (pickerStage === "minutes") {
    <div class="not-selectable">
      <div class="col-md" #container mat-dialog-content>
        @for (minute of minutes; track minute; let i = $index) {
          <div class="d-flex justify-content-center align-items-center">
            <div>
              @if (minutePositions[i]) {
                <div [ngStyle]="{ top: minutePositions[i].y + 'px', left: minutePositions[i].x + 'px' }" (click)="selectMinutes(minute)" class="minute">
                  @if (minute === minutes[selectedMinute] && minute % 5 === 0) {
                    <button class="selectedButton" mat-flat-button>
                      {{ minute | number: "1.0-0" }}
                    </button>
                  }
                  @if (minute !== minutes[selectedMinute] && minute % 5 === 0) {
                    <button class="clockButton" mat-flat-button>
                      {{ minute | number: "1.0-0" }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (containerMiddle) {
    <div>
      <div class="not-selectable clockMiddlePoint" [ngStyle]="{ top: containerMiddle.y * 1.75 - 2.5 + 'px', left: containerMiddle!.x - 3.5 + 'px' }"></div>
      @if (pickerStage === "minutes" && selectedMinute % 5 === 0) {
        <div
          class="not-selectable clockHand"
          [style.transform]="'rotate(' + ((360 / 60) * selectedMinute - 180) + 'deg)'"
          [style.transform-origin]="'top'"
          [ngStyle]="{ top: containerMiddle.y * 1.75 + 2 + 'px', left: containerMiddle!.x - 1 + 'px', height: containerMiddle.x / 1.5 + 'px' }"
        ></div>
      }
      @if (pickerStage === "minutes" && selectedMinute % 5 !== 0) {
        <div
          class="not-selectable clockHand"
          [style.transform]="'rotate(' + ((360 / 60) * selectedMinute - 180) + 'deg)'"
          [style.transform-origin]="'top'"
          [ngStyle]="{ top: containerMiddle.y * 1.75 + 2 + 'px', left: containerMiddle!.x - 1 + 'px', height: containerMiddle.x / 1.25 + 'px' }"
        >
          <!-- Clockhand circle  -->
          <div class="minuteDot not-selectable"></div>
        </div>
      }
      <!-- uren staan hier -->
      @if (pickerStage === "hours" && selectedHour < 12) {
        <div
          class="not-selectable clockHand"
          [style.transform]="'rotate(' + ((360 / 12) * selectedHour - 180) + 'deg)'"
          [style.transform-origin]="'top'"
          [ngStyle]="{ top: containerMiddle.y * 1.75 + 2 + 'px', left: containerMiddle!.x - 1 + 'px', height: containerMiddle.x / 1.25 + 'px' }"
        ></div>
      }
      @if (pickerStage === "hours" && selectedHour >= 12) {
        <div
          class="not-selectable clockHand"
          [style.transform]="'rotate(' + ((360 / 12) * selectedHour - 180) + 'deg)'"
          [style.transform-origin]="'top'"
          [ngStyle]="{ top: containerMiddle.y * 1.75 + 2 + 'px', left: containerMiddle!.x - 1 + 'px', height: containerMiddle.x / 1.75 + 'px' }"
        ></div>
      }
    </div>
  }
</section>
<section class="buttons">
  <div class="d-flex justify-content-end">
    <div>
      <button mat-button (click)="dialogRef.close()">
        <span>{{ "TIME_PICKER.CANCEL" | translate | uppercase }}</span>
      </button>
    </div>
    <div class="align-self-center">
      <button mat-button (click)="okButtonHandler()">
        <span>{{ "TIME_PICKER.SAVE" | translate | uppercase }}</span>
      </button>
    </div>
  </div>
</section>
